var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-3 bg-white rounded-lg shadow-md px-3 py-2.5"
  }, [_c('h4', {
    staticClass: "text-xl font-bold py-2"
  }, [_vm._v("Logged Device Details")]), _c('div', {
    staticClass: "relative overflow-x-auto my-2 mb-4 rounded-lg border-gray-200 border-b border-t border-r border-l"
  }, [_c('Table', {
    attrs: {
      "headers": _vm.headers,
      "data": _vm.User[0].devices,
      "row-key": ['device_id', 'device_model', 'ip_address', 'modified'],
      "isLoading": _vm.isLoading,
      "withPagination": false
    },
    scopedSlots: _vm._u([{
      key: "device_id",
      fn: function (_ref) {
        var value = _ref.value;
        return [_c('span', [_vm._v(" " + _vm._s(value[0]) + " ")])];
      }
    }, {
      key: "modified",
      fn: function (_ref2) {
        var value = _ref2.value;
        return [_c('span', [_vm._v(_vm._s(_vm.formatDateTime(value).date))]), _c('br'), _c('span', {
          staticClass: "italic text-xs"
        }, [_vm._v(_vm._s(_vm.formatDateTime(value).time))])];
      }
    }, {
      key: "actions",
      fn: function (_ref3) {
        var row = _ref3.row;
        return [_c('button', {
          staticClass: "bg-white border cursor-pointer p-2 rounded-lg",
          on: {
            "click": function ($event) {
              return _vm.showPopup(row.id);
            }
          }
        }, [_vm._v(" Remove Device ")])];
      }
    }])
  }), _c('t-modal', {
    ref: "removeDeviceModal"
  }, [_c('div', {
    staticClass: "text-sm flex-col text-center"
  }, [_c('label', {
    staticClass: "text-center font-semibold"
  }, [_vm._v("Remove this device?")]), _c('p', {
    staticClass: "text-left text-gray-500"
  }, [_vm._v(" The data of device will be lost, still want to continue? ")])]), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('button', {
    staticClass: "bg-blue-500 text-white p-1 px-2 rounded-lg mr-1 text-sm",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" Cancel ")]), _c('button', {
    staticClass: "bg-white border text-gray-500 p-1 px-2 rounded-lg ml-1 text-sm",
    on: {
      "click": _vm.handleRemoveDevice
    }
  }, [_vm._v(" Yes ")])])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }